const styObj = {
  default: {
    '--base-fontfamily': 'Inter-TightRegular',
    '--pay-color0': '#333333',
    '--pay-color1': '#333333',
    '--pay-color2': '#333333',
    '--pay-color3': '#ff4265',
    '--pay-color4': '#666666',
    '--pay-color5': '#b2b2b2',
    '--pay-color6': '#333333',
    '--pay-color7': '#b2b2b2',
    '--pay-color8': '#666666',
    '--pay-color9': '#b2b2b2',
    '--pay-color10': '#ffffff',
    '--pay-color11': '#333333',
    '--pay-color12': '#f95151',
    '--pay-color13': '#333333',
    '--pay-color14': '#ffffff',
    '--pay-color15': '#C36F00',
    '--pay-bg1': '#f9f9fb',
    '--pay-bg2': '#fefefe',
    '--pay-bg3': '#f9f9fb',
    '--pay-bg4': '#ffffff',
    '--pay-bg5': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg6': '#a338fc',
    '--pay-bg7': 'rgba(249, 249, 251, 0.8)',
    '--pay-bg8': 'rgba(255, 187, 40, 0.10)',
    '--pay-radius01': '100px',
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.png')})`,
    '--icon-check2': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon.png')})`,
    '--icon-check3': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon-ar.png')})`
  },
  echo: {
    '--base-fontfamily': 'Outfit-Regular',
    '--pay-color0': '#222222',
    '--pay-color1': '#222222',
    '--pay-color2': '#222222',
    '--pay-color3': '#f95151',
    '--pay-color4': '#222222',
    '--pay-color5': '#999999',
    '--pay-color6': '#222222',
    '--pay-color7': '#999999',
    '--pay-color8': '#222222',
    '--pay-color9': '#aeaeb2',
    '--pay-color10': '#ffffff',
    '--pay-color11': '#222222',
    '--pay-color12': '#f95151',
    '--pay-color13': '#222222',
    '--pay-color14': '#ffffff',
    '--pay-color15': '#C36F00',
    '--pay-bg1': '#f4f5f7',
    '--pay-bg2': '#fefefe',
    '--pay-bg3': '#f9f9fb',
    '--pay-bg4': '#ffffff',
    '--pay-bg5': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg6': '#ff7f2d',
    '--pay-bg7': 'rgba(255, 255, 255, 0.8)',
    '--pay-bg8': 'rgba(255, 187, 40, 0.10)',
    '--pay-radius01': '100px',
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.png')})`,
    '--icon-check2': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check-icon.png')})`,
    '--icon-check3': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/echo/check-icon-ar.png')})`
  },
  joychat: {
    '--base-fontfamily': 'Lato-Regular',
    '--pay-color0': '#222222',
    '--pay-color1': '#222222',
    '--pay-color2': '#222222',
    '--pay-color3': '#f95151',
    '--pay-color4': '#222222',
    '--pay-color5': '#999999',
    '--pay-color6': '#222222',
    '--pay-color7': '#999999',
    '--pay-color8': '#666666',
    '--pay-color9': '#aeaeb2',
    '--pay-color10': '#ffffff',
    '--pay-color11': '#222222',
    '--pay-color12': '#f95151',
    '--pay-color13': '#222222',
    '--pay-color14': '#ffffff',
    '--pay-color15': '#C36F00',
    '--pay-bg1': '#f9f9fb',
    '--pay-bg2': '#fefefe',
    '--pay-bg3': '#f9f9fb',
    '--pay-bg4': '#ffffff',
    '--pay-bg5': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg6': '#22c185',
    '--pay-bg7': 'rgba(249, 249, 251, 0.8)',
    '--pay-bg8': 'rgba(255, 187, 40, 0.10)',
    '--pay-radius01': '100px',
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.png')})`,
    '--icon-check2': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check-icon.png')})`,
    '--icon-check3': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joychat/check-icon-ar.png')})`
  },
  joyu: {
    '--base-fontfamily': 'NotoSans-Regular',
    '--pay-color0': '#0C0E11',
    '--pay-color1': '#0C0E11',
    '--pay-color2': '#353A3F',
    '--pay-color3': '#FF5526',
    '--pay-color4': '#353A3F',
    '--pay-color5': '#8E9092',
    '--pay-color6': '#0C0E11',
    '--pay-color7': '#8E9092',
    '--pay-color8': '#353A3F',
    '--pay-color9': '#8E9092',
    '--pay-color10': '#5A0B1B',
    '--pay-color11': '#0C0E11',
    '--pay-color12': '#FF5526',
    '--pay-color13': '#353A3F',
    '--pay-color14': '#5A0B1B',
    '--pay-color15': '#C36F00',
    '--pay-bg1': '#F4F5F7',
    '--pay-bg2': '#ffffff',
    '--pay-bg3': '#F4F5F7',
    '--pay-bg4': '#ffffff',
    '--pay-bg5': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg6': '#FF6A55',
    '--pay-bg7': 'transparent',
    '--pay-bg8': 'rgba(255, 187, 40, 0.10)',
    '--pay-radius01': '4px',
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.png')})`,
    '--icon-check2': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check-icon.png')})`,
    '--icon-check3': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/joyu/check-icon-ar.png')})`
  },
  kiko: {
    '--base-fontfamily': 'Inter-Tight',
    '--pay-color0': '#333333',
    '--pay-color1': '#333333',
    '--pay-color2': '#333333',
    '--pay-color3': '#ff4265',
    '--pay-color4': '#666666',
    '--pay-color5': '#b2b2b2',
    '--pay-color6': '#333333',
    '--pay-color7': '#b2b2b2',
    '--pay-color8': '#666666',
    '--pay-color9': '#b2b2b2',
    '--pay-color10': '#000000',
    '--pay-color11': '#333333',
    '--pay-color12': '#f95151',
    '--pay-color13': '#333333',
    '--pay-color14': '#000000',
    '--pay-color15': '#C36F00',
    '--pay-bg1': '#f9f9fb',
    '--pay-bg2': '#fefefe',
    '--pay-bg3': '#f9f9fb',
    '--pay-bg4': '#ffffff',
    '--pay-bg5': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg6': '#ffe242',
    '--pay-bg7': 'rgba(249, 249, 251, 0.8)',
    '--pay-bg8': 'rgba(255, 187, 40, 0.10)',
    '--pay-radius01': '100px',
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.png')})`,
    '--icon-check2': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check-icon.png')})`,
    '--icon-check3': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/kiko/check-icon-ar.png')})`
  },
  vava: {
    '--base-fontfamily': 'Inter-Tight',
    '--pay-color0': '#333333',
    '--pay-color1': '#333333',
    '--pay-color2': '#333333',
    '--pay-color3': '#ff4265',
    '--pay-color4': '#666666',
    '--pay-color5': '#b2b2b2',
    '--pay-color6': '#333333',
    '--pay-color7': '#b2b2b2',
    '--pay-color8': '#666666',
    '--pay-color9': '#b2b2b2',
    '--pay-color10': '#ffffff',
    '--pay-color11': '#333333',
    '--pay-color12': '#f95151',
    '--pay-color13': '#333333',
    '--pay-color14': '#ffffff',
    '--pay-color15': '#C36F00',
    '--pay-bg1': '#f9f9fb',
    '--pay-bg2': '#fefefe',
    '--pay-bg3': '#f9f9fb',
    '--pay-bg4': '#ffffff',
    '--pay-bg5': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg6': '#a338fc',
    '--pay-bg7': 'rgba(249, 249, 251, 0.8)',
    '--pay-bg8': 'rgba(255, 187, 40, 0.10)',
    '--pay-radius01': '100px',
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.png')})`,
    '--icon-check2': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon.png')})`,
    '--icon-check3': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/check-icon-ar.png')})`
  },
  vibeo: {
    '--base-fontfamily': 'Inter-Tight',
    '--pay-color0': '#333333',
    '--pay-color1': '#333333',
    '--pay-color2': '#333333',
    '--pay-color3': '#ff4265',
    '--pay-color4': '#666666',
    '--pay-color5': '#b2b2b2',
    '--pay-color6': '#333333',
    '--pay-color7': '#b2b2b2',
    '--pay-color8': '#666666',
    '--pay-color9': '#b2b2b2',
    '--pay-color10': '#733406',
    '--pay-color11': '#333333',
    '--pay-color12': '#f95151',
    '--pay-color13': '#333333',
    '--pay-color14': '#733406',
    '--pay-color15': '#C36F00',
    '--pay-bg1': '#f9f9fb',
    '--pay-bg2': '#fefefe',
    '--pay-bg3': '#f9f9fb',
    '--pay-bg4': '#ffffff',
    '--pay-bg5': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg6': '#ffa433',
    '--pay-bg7': 'rgba(249, 249, 251, 0.8)',
    '--pay-bg8': 'rgba(255, 187, 40, 0.10)',
    '--pay-radius01': '100px',
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.png')})`,
    '--icon-check2': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check-icon.png')})`,
    '--icon-check3': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/vibeo/check-icon-ar.png')})`
  },
  whonow: {
    '--base-fontfamily': 'Manrope-Regular',
    '--pay-color0': '#0C0E11',
    '--pay-color1': '#222222',
    '--pay-color2': '#222222',
    '--pay-color3': '#F95151',
    '--pay-color4': '#666666',
    '--pay-color5': '#999999',
    '--pay-color6': '#222222',
    '--pay-color7': '#b2b2b2',
    '--pay-color8': '#222222',
    '--pay-color9': '#8E9092',
    '--pay-color10': '#0C0E11',
    '--pay-color11': '#222222',
    '--pay-color12': '#F95151',
    '--pay-color13': '#222222',
    '--pay-color14': '#102006',
    '--pay-color15': '#C36F00',
    '--pay-bg1': '#F4F5F7',
    '--pay-bg2': '#ffffff',
    '--pay-bg3': '#f9f9fb',
    '--pay-bg4': '#ffffff',
    '--pay-bg5': 'rgba(255, 66, 101, 0.05)',
    '--pay-bg6': '#B9E86F',
    '--pay-bg7': '#ffffff',
    '--pay-bg8': 'rgba(255, 187, 40, 0.10)',
    '--pay-radius01': '100px',
    '--icon-arrow': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.png')})`,
    '--icon-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check.png')})`,
    '--icon-not-check': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/default/not-check.png')})`,
    '--icon-check2': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check-icon.png')})`,
    '--icon-check3': `url(${require('@/assets/packageAssets/views/P1_Boys/PayNext/whonow/check-icon-ar.png')})`
  }
}

export const pageCssVars = {
  methods: {
    cssVars() {
      if (this.packageName) {
        // 有配置
        if (styObj[this.packageName]) {
          return styObj[this.packageName]
        }
        // 未配置
        else {
          return styObj['default']
        }
      }
      return {}
    }
  }
}
